import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';
import { transformToSelectOptions } from '~/utils/common';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type {
  DeliveryAgencyReportFilterOptions,
  GetDeliveryResultReportsSearchConditionsResponse,
} from '~/types/delivery-agency.types';

/**
 * [배송 결과 리포트] 검색 조건 코드 조회 API
 */
export const fetchDeliveryResultReportsSearchConditions = async (): Promise<
  GetDeliveryResultReportsSearchConditionsResponse['data']
> => {
  const { data } = await axiosInstance.get<GetDeliveryResultReportsSearchConditionsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_DELIVERY_RESULT_REPORTS_CODES
  );
  return data.data;
};

/**
 * [배송 결과 리포트] 검색 조건 코드 조회 Query Hook
 */
export const useGetDeliveryResultReportsSearchConditionsQuery = (options?: { enabled?: boolean; silent?: boolean }) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.deliveryResultReportsSearchConditions(),
    queryFn: fetchDeliveryResultReportsSearchConditions,
    staleTime: 1000 * 60 * 30,
    enabled: options?.enabled ?? true,
    meta: { silent: options?.silent },
    select: (data): DeliveryAgencyReportFilterOptions => ({
      searchKeywordTypes: transformToSelectOptions(data.searchKeywordTypes, 'code', 'description'),
      shippingLabelStatuses: transformToSelectOptions(data.reportedShippingLabelStatuses, 'code', 'description'),
      deliveryFailureReasonCategories: transformToSelectOptions(
        data.deliveryFailureReasonCategories,
        'code',
        'description'
      ),
      deliveryTypes: transformToSelectOptions(data.deliveryTypes, 'code', 'description'),
      deliveryResults: transformToSelectOptions(data.deliveryResults, 'code', 'description'),
    }),
  });
};
